import { render, staticRenderFns } from "./goodsReportList.vue?vue&type=template&id=347243ec&scoped=true&"
import script from "./goodsReportList.vue?vue&type=script&lang=js&"
export * from "./goodsReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347243ec",
  null
  
)

component.options.__file = "goodsReportList.vue"
export default component.exports